module.exports = __webpack_public_path__ + "pc-top-assets/img/facebook-black.319d0c32.png";